import { useEffect, useRef, useState } from "react";
import "../styles/slideshow.scss"
import { createSearchParams, useNavigate } from "react-router-dom";
import ContactUs from "./contact-us";

import { useSwipeable } from 'react-swipeable';
import * as Query from "../static data/queryparams";
import * as Constants from "../config";
import { useTranslation } from "react-i18next";

export default function Slideshow(props){
        const { t } = useTranslation();
    const timeoutRef = useRef(null);

    const initialTexts = [
        "Trouvez une propriété qui correspond à votre style de vie et à vos besoins",
        "Achetez une maison où vous et vos proches vous sentirez bien",
        "Nous résolvons tous les problèmes juridiques pour vous"
    ];

    const [data, setData] = useState();
    const [loaded,setLoaded] = useState(false);
    const [modalOpened,setModalOpened] = useState(false);

    const [currentIndex, setCurrentIndex] = useState({"ind":-1,timer: false});

    const [stopTimer, setStopTimer] = useState(false);

    const navigate = useNavigate();

    const bgimage = {
        backgroundImage: "url("+""+")",
    };

    function openDetails(id){
        let search = window.location.search;
        let params = new URLSearchParams(search);
        params.delete(Query.id);
        params.append(Query.id, id);
        navigate({
            pathname: "/apart",
            search: createSearchParams(params).toString()
        });
    }

    function getData() {
        fetch(Constants.apiurl + Constants.slides)
        .then((response) => response.json())
        .then((data) => {
            const sorted = data.sort((a, b) => a.order - b.order);
            setData(sorted);
            console.log(data);
            setCurrentIndex({"ind":0, timer: true});
            loadImages(data);
        })
        .catch((err) => {
           console.log(err.message);
        });
    }

    useEffect(() => {
        getData();
     }, []);

    const loadImages = (ldata) =>{
        ldata.forEach((picture) => {
            const img = new Image();
            img.src = picture.image[0].link;
        });
     }

    function slideRight(){   
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setStopTimer(true);     
        var newObj = {};
        Object.assign(newObj, currentIndex);
        newObj.ind--;
        newObj.timer = false;
        if(newObj.ind < 0)    
            newObj.ind = data.length-1;
        setCurrentIndex(newObj);   
    }

    function slideLeft(){                
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }     
        setStopTimer(true);    
        var newObj = {};
        Object.assign(newObj, currentIndex);        
        newObj.timer = false;
        newObj.ind++;
        if(newObj.ind > data.length - 1)    
            newObj.ind = 0;
        setCurrentIndex(newObj);       
    }

     function changePicture(){
        if(!currentIndex.timer) return;
        var newObj = {};
        Object.assign(newObj, currentIndex);
        newObj.ind++;
        if( newObj.ind == data.length){
            newObj.ind = 0;
            if(!newObj.timer) return;
            setCurrentIndex(newObj);
        }
        else
        {
            if(!newObj.timer) return;
            setCurrentIndex(newObj);
        }
     }

     function changePictureByIndex(index){        
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setStopTimer(true);
        setCurrentIndex({"ind":index, timer: false});
    }

     const CHANGE_MS = 4000;

    useEffect(() => {        
        if (!data || !currentIndex.timer || stopTimer) return;

        timeoutRef.current = setTimeout(() => {            
            changePicture();
        }, CHANGE_MS);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [currentIndex]);

    function CloseModal(){
        setModalOpened(false);
     }

    const handlers = useSwipeable({
        onSwipedLeft: () => slideLeft(),
        onSwipedRight: () => slideRight(),
        swipeDuration: 700,
        preventScrollOnSwipe: true,
        trackMouse: true
      });

    return(
        <>
        
        <div id="slideshowheader">
            
            {modalOpened ? <ContactUs closeModal = {CloseModal}/> : ""}
            <div {...handlers} className="slideshow-element" key={currentIndex.ind + "slide"}>
                {loaded && !!(data) ?
                <div id='text-block'>
                    <div id='text-content'>    
                        <div id="title">
                            {data[currentIndex.ind].title}  
                        </div>
                        <div id="text" key={currentIndex.ind}>
                            {data[currentIndex.ind].text}
                        </div>
                        <div id="buttons">
                            <div>
                                <div onClick={()=>navigate("apartments-search")}  className="white-button">{t('Voir toutes les offres')}</div>
                                {data[currentIndex.ind].link != "" && data[currentIndex.ind].link != undefined ?
                                    <div onClick={()=>openDetails(data[currentIndex.ind].link)} className="blue-button">{t('Voir cette offre')}</div>
                                    :
                                    <div onClick={()=>setModalOpened(true)} className="blue-button">{t('Laisser une demande')}</div>
                                }
                            </div>
                        </div>
                    </div>
                    <div id='circles'>
                        {!!(data) ? data.map((x,i)=> 
                            <>
                                <div onClick={()=>changePictureByIndex(i)} className={currentIndex.ind == i ? "active" : "inactive"}></div>
                            </>
                        ) : ""}
                       
                    </div>
                </div>
                :
                ""
                }
                
                <div id='image' key={currentIndex.ind + "image"}>
                    <img style={{display: loaded? 'block': 'none'}} onLoad={()=>setLoaded(true)} src={ !!(data) ? data[currentIndex.ind].image[0].link : ""}/>
                    {/*  */}
                </div>
             </div>
            {!loaded ? 
                <div className="loader-box">
                <div className="loader"></div> 
                </div>: ""
            }

        </div>
        

        </>
    )
}
